import { WorkOpportunity } from "../../../../store/services/opportunityService";

// Hjälpfunktioner för statistik
export const calculateStatistics = (opportunities: WorkOpportunity[]) => {
  if (!opportunities || opportunities.length === 0) {
    return {
      totalValue: 0,
      highestValueOpportunity: null,
      averageProbability: 0,
      topOpportunities: [],
      byMonth: {},
    };
  }

  const totalValue = opportunities.reduce(
    (sum, opp) => sum + (opp.OpportunityTotalAmount || 0),
    0
  );

  const highestValueOpportunity = [...opportunities].sort(
    (a, b) => (b.OpportunityTotalAmount || 0) - (a.OpportunityTotalAmount || 0)
  )[0];

  const validProbabilityOpps = opportunities.filter(
    (opp) =>
      opp.OpportunityProbability !== null &&
      opp.OpportunityProbability !== undefined
  );

  const averageProbability = validProbabilityOpps.length
    ? validProbabilityOpps.reduce(
        (sum, opp) => sum + (opp.OpportunityProbability || 0),
        0
      ) / validProbabilityOpps.length
    : 0;

  // Topp 5 opportunities med högst sannolikhet och värde
  const topOpportunities = [...opportunities]
    .sort((a, b) => {
      // Sortera först efter sannolikhet, sedan värde
      const probDiff =
        (b.OpportunityProbability || 0) - (a.OpportunityProbability || 0);
      if (probDiff !== 0) return probDiff;
      return (b.OpportunityTotalAmount || 0) - (a.OpportunityTotalAmount || 0);
    })
    .slice(0, 5);

  // Gruppera efter månad
  const byMonth: Record<string, { count: number; value: number }> = {};
  opportunities.forEach((opp) => {
    if (opp.OpportunityCloseDate) {
      const date = new Date(opp.OpportunityCloseDate);
      const monthKey = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;

      if (!byMonth[monthKey]) {
        byMonth[monthKey] = { count: 0, value: 0 };
      }

      byMonth[monthKey].count += 1;
      byMonth[monthKey].value += opp.OpportunityTotalAmount || 0;
    }
  });

  return {
    totalValue,
    highestValueOpportunity,
    averageProbability,
    topOpportunities,
    byMonth,
  };
};

